import { TopBar } from "../../app/newLayout/components/TopBar/TopBar";
import { OperationsControlCentre } from "./OperationsControlCentre";

/** @return {JSX.Element} Dashboard with the shared persistent module top bar. */
const DashboardWrapper = () => (
  <div className="operations-workspace">
    <TopBar title="Operations Control Centre" />
    <OperationsControlCentre />
  </div>
);

export { DashboardWrapper };
